import { createFileRoute } from '@tanstack/react-router'
import { cleanerPageSearchSchema } from '@/features/cleaners/model'
import { CleanerScreen } from '@/features/cleaners/routes/cleaner-screen'

export const Route = createFileRoute('/cleaners/$cleanerId')({
  // ?tab=overview | jobs | messages
  validateSearch: cleanerPageSearchSchema,
  component: CleanerPage,
})

function CleanerPage() {
  const { cleanerId } = Route.useParams()
  const { tab } = Route.useSearch()
  return <CleanerScreen cleanerId={cleanerId} tab={tab ?? 'overview'} />
}
